(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types')) :
	typeof define === 'function' && define.amd ? define(['react', 'prop-types'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React, global.PropTypes)));
})(this, (function (React, require$$1) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	var classnames = {exports: {}};

	/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/

	(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
	}(classnames));

	var classNames = classnames.exports;

	var dist$1 = {exports: {}};

	(function (module, exports) {
	(function (global, factory) {
	  factory(exports, React__default["default"], require$$1__default["default"]) ;
	})(commonjsGlobal, (function (exports, React, PropTypes) {
	  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

	  function styleInject(css, ref) {
	    if (ref === void 0) ref = {};
	    var insertAt = ref.insertAt;

	    if (!css || typeof document === 'undefined') {
	      return;
	    }

	    var head = document.head || document.getElementsByTagName('head')[0];
	    var style = document.createElement('style');
	    style.type = 'text/css';

	    if (insertAt === 'top') {
	      if (head.firstChild) {
	        head.insertBefore(style, head.firstChild);
	      } else {
	        head.appendChild(style);
	      }
	    } else {
	      head.appendChild(style);
	    }

	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	  }

	  var css_248z$1 = "/* Consolidation of frequently used colours throughout the repo */\n.primary_button {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ffffff;\n  background: #051d33;\n  border: 1px solid transparent; }\n  .primary_button span {\n    text-align: center; }\n  .primary_button[disabled] {\n    background: #eeeeee;\n    border: 1px solid #c3c3c3;\n    color: #6b6b6b !important;\n    pointer-events: none; }\n  .primary_button:hover {\n    background: #024055;\n    border: 1px solid #051d33; }\n  .primary_button:focus {\n    background: #024055;\n    border: 1px solid #051d33; }\n  .primary_button:active {\n    border: 1px solid #051d33; }\n  .primary_button .icon {\n    padding-right: 10px; }\n\n.primary_button_outline {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #051d33;\n  background: #ffffff;\n  border: 1px solid #051d33; }\n  .primary_button_outline span {\n    text-align: center; }\n  .primary_button_outline[disabled] {\n    background: #eeeeee;\n    border: 1px solid #c3c3c3;\n    color: #6b6b6b !important;\n    pointer-events: none; }\n  .primary_button_outline:hover {\n    background: #f3fafd;\n    border: 1px solid #17a2b8; }\n  .primary_button_outline:focus {\n    border: 1px solid #6dc7be; }\n  .primary_button_outline:active {\n    border: 1px solid #051d33;\n    color: #051d33; }\n  .primary_button_outline .icon {\n    padding-right: 10px; }\n\n.primary_button_outline_danger {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ab1212;\n  background: #ffffff;\n  border: 1px solid #ab1212; }\n  .primary_button_outline_danger span {\n    text-align: center; }\n  .primary_button_outline_danger[disabled] {\n    background: #eeeeee;\n    border: 1px solid #c3c3c3;\n    color: #6b6b6b !important;\n    pointer-events: none; }\n  .primary_button_outline_danger:hover {\n    background: #f3fafd;\n    border: 1px solid #dc3545;\n    color: #dc3545 !important; }\n  .primary_button_outline_danger:focus {\n    border: 1px solid #dc3545;\n    color: #dc3545 !important; }\n  .primary_button_outline_danger:active {\n    border: 1px solid #051d33; }\n  .primary_button_outline_danger .icon {\n    padding-right: 10px; }\n";
	  styleInject(css_248z$1);

	  var PrimaryButton = function (_a) {
	      var style = _a.style, _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { return null; } : _b, isDisabled = _a.isDisabled, children = _a.children, title = _a.title, type = _a.type, variant = _a.variant, delay = _a.delay, ariaLabel = _a.ariaLabel;
	      var _c = React.useState(false), isClicked = _c[0], setButtonState = _c[1];
	      var class_name = variant === ''
	          ? 'primary_button'
	          : variant === 'outline'
	              ? 'primary_button_outline'
	              : 'primary_button_outline_danger';
	      var handleClick = function () {
	          if (!isClicked) {
	              setButtonState(true);
	              clickHandler();
	              setTimeout(function () {
	                  setButtonState(false);
	              }, delay);
	          }
	          return null;
	      };
	      return (
	      // eslint-disable-next-line react/button-has-type
	      React__default["default"].createElement("button", { "aria-label": type, type: type, className: class_name, style: style, onClick: handleClick, disabled: isDisabled, title: ariaLabel },
	          children && React__default["default"].createElement("span", { className: 'icon' }, children),
	          " ",
	          React__default["default"].createElement("span", null, title),
	          ' '));
	  };
	  PrimaryButton.propTypes = {
	      style: PropTypes__default["default"].object,
	      type: PropTypes__default["default"].oneOf(['button', 'submit', 'reset']),
	      clickHandler: PropTypes__default["default"].func,
	      title: PropTypes__default["default"].any.isRequired,
	      isDisabled: PropTypes__default["default"].bool,
	      children: PropTypes__default["default"].any,
	      variant: PropTypes__default["default"].oneOf(['', 'outline', 'danger']),
	      delay: PropTypes__default["default"].number,
	      ariaLabel: PropTypes__default["default"].string
	  };
	  PrimaryButton.defaultProps = {
	      style: {},
	      type: 'button',
	      clickHandler: function () { return null; },
	      isDisabled: false,
	      children: '',
	      variant: '',
	      delay: 1000,
	      ariaLabel: ''
	  };

	  var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.secondary_button {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #051d33;\n  background: #ffffff;\n  border: 1px solid #051d33; }\n  .secondary_button span {\n    text-align: center; }\n  .secondary_button[disabled] {\n    background: #eeeeee;\n    border: 1px solid #c3c3c3;\n    color: #6b6b6b !important;\n    pointer-events: none; }\n  .secondary_button .icon {\n    padding-right: 10px; }\n";
	  styleInject(css_248z);

	  var SecondaryButton = function (_a) {
	      var _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { return null; } : _b, isDisabled = _a.isDisabled, children = _a.children, title = _a.title, type = _a.type, style = _a.style;
	      var _c = React.useState(false), isClicked = _c[0], setButtonState = _c[1];
	      var handleClick = function () {
	          if (!isClicked) {
	              setButtonState(true);
	              clickHandler();
	              setTimeout(function () {
	                  setButtonState(false);
	              }, 1000);
	          }
	          return null;
	      };
	      return (
	      // eslint-disable-next-line react/button-has-type
	      React__default["default"].createElement("button", { type: type, className: 'secondary_button', style: style, onClick: handleClick, disabled: isDisabled || false },
	          children && React__default["default"].createElement("span", { className: 'icon' }, children),
	          " ",
	          React__default["default"].createElement("span", null, title),
	          ' '));
	  };
	  SecondaryButton.propTypes = {
	      style: PropTypes__default["default"].object,
	      type: PropTypes__default["default"].oneOf(['button', 'submit', 'reset']),
	      clickHandler: PropTypes__default["default"].func,
	      title: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]).isRequired,
	      isDisabled: PropTypes__default["default"].bool,
	      children: PropTypes__default["default"].any
	  };
	  SecondaryButton.defaultProps = {
	      style: {},
	      type: 'button',
	      clickHandler: function () { return null; },
	      isDisabled: false,
	      children: ''
	  };

	  exports.PrimaryButton = PrimaryButton;
	  exports.SecondaryButton = SecondaryButton;

	  Object.defineProperty(exports, '__esModule', { value: true });

	}));
	}(dist$1, dist$1.exports));

	var dist = {exports: {}};

	(function (module, exports) {
	(function (global, factory) {
	    module.exports = factory(React__default["default"]) ;
	})(commonjsGlobal, (function (React) {
	    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

	    var _assign = function __assign() {
	      _assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	      };
	      return _assign.apply(this, arguments);
	    };

	    var classnames = {exports: {}};

	    /*!
	    	Copyright (c) 2018 Jed Watson.
	    	Licensed under the MIT License (MIT), see
	    	http://jedwatson.github.io/classnames
	    */

	    (function (module) {
	    /* global define */

	    (function () {

	    	var hasOwn = {}.hasOwnProperty;

	    	function classNames() {
	    		var classes = [];

	    		for (var i = 0; i < arguments.length; i++) {
	    			var arg = arguments[i];
	    			if (!arg) continue;

	    			var argType = typeof arg;

	    			if (argType === 'string' || argType === 'number') {
	    				classes.push(arg);
	    			} else if (Array.isArray(arg)) {
	    				if (arg.length) {
	    					var inner = classNames.apply(null, arg);
	    					if (inner) {
	    						classes.push(inner);
	    					}
	    				}
	    			} else if (argType === 'object') {
	    				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
	    					classes.push(arg.toString());
	    					continue;
	    				}

	    				for (var key in arg) {
	    					if (hasOwn.call(arg, key) && arg[key]) {
	    						classes.push(key);
	    					}
	    				}
	    			}
	    		}

	    		return classes.join(' ');
	    	}

	    	if (module.exports) {
	    		classNames.default = classNames;
	    		module.exports = classNames;
	    	} else {
	    		window.classNames = classNames;
	    	}
	    }());
	    }(classnames));

	    var classNames = classnames.exports;

	    function styleInject(css, ref) {
	      if (ref === void 0) ref = {};
	      var insertAt = ref.insertAt;
	      if (!css || typeof document === 'undefined') {
	        return;
	      }
	      var head = document.head || document.getElementsByTagName('head')[0];
	      var style = document.createElement('style');
	      style.type = 'text/css';
	      if (insertAt === 'top') {
	        if (head.firstChild) {
	          head.insertBefore(style, head.firstChild);
	        } else {
	          head.appendChild(style);
	        }
	      } else {
	        head.appendChild(style);
	      }
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	    }

	    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.responsive_link {\n  display: flex;\n  gap: 0.5rem;\n  cursor: pointer;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  justify-items: flex-end;\n  text-decoration: none;\n  font-family: \"AvenirLTStd-65-Medium\";\n}\n.responsive_link > .link_text {\n  display: flex;\n  align-items: center;\n  color: #007191;\n  font-weight: 550;\n  font-size: 0.875rem;\n  cursor: pointer;\n  line-height: 1.43;\n}\n.responsive_link > .link_children_wrapper {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n}\n.responsive_link.disabled {\n  pointer-events: none;\n}\n.responsive_link.disabled > .link_text {\n  color: #707272;\n}\n.responsive_link.disabled > .link_children_wrapper > svg > path {\n  fill: #707272;\n}\n.responsive_link:active[aria-disabled=false] {\n  background-color: #c8e6f1;\n  text-decoration-color: #004c60;\n}\n.responsive_link:focus[aria-disabled=false] {\n  outline: 2px solid #004c60;\n  border-radius: 5px;\n}\n.responsive_link:hover[aria-disabled=false] {\n  text-decoration: underline;\n  text-decoration-color: #004c60;\n}\n.responsive_link:active[aria-disabled=true] {\n  background-color: transparent;\n}\n.responsive_link:focus[aria-disabled=true] {\n  box-shadow: none;\n  border-radius: 0;\n}\n.responsive_link:hover[aria-disabled=true] {\n  text-decoration: none;\n}";
	    styleInject(css_248z);

	    var ResponsiveLink = function (_a) {
	        var linkText = _a.linkText, link = _a.link, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, children = _a.children, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'right' : _c, _d = _a.textStyle, textStyle = _d === void 0 ? {} : _d, _e = _a.linkAnchorAttributes, linkAnchorAttributes = _e === void 0 ? {} : _e;
	        var anchorAttributes = {};
	        if (!isDisabled) {
	            switch (typeof link) {
	                case 'string':
	                    anchorAttributes = _assign(_assign({}, linkAnchorAttributes), { href: link });
	                    break;
	                case 'function':
	                    anchorAttributes = _assign(_assign({}, linkAnchorAttributes), { onClick: link, onKeyDown: function (event) {
	                            if (event.key === 'Enter') {
	                                event.preventDefault();
	                                link();
	                            }
	                        } });
	                    break;
	            }
	        }
	        // Not using row-reverse
	        var childrenNode = children && (React__default["default"].createElement("div", { className: 'link_children_wrapper', "data-testid": 'link_children_wrapper' }, children));
	        return (React__default["default"].createElement("a", _assign({ className: classNames({
	                responsive_link: true,
	                disabled: isDisabled,
	            }), tabIndex: isDisabled ? -1 : 0, "aria-label": linkText, "aria-disabled": isDisabled, "data-testid": 'link' }, anchorAttributes),
	            iconPosition === 'left' && childrenNode,
	            React__default["default"].createElement("p", { className: classNames({ link_text: true, disabled: isDisabled }), style: textStyle }, linkText),
	            iconPosition === 'right' && childrenNode));
	    };

	    return ResponsiveLink;

	}));
	}(dist));

	var ResponsiveLink = dist.exports;

	var ThinLeftArrowIcon = function (_a) {
	    var _b = _a.width, width = _b === void 0 ? '25' : _b, _c = _a.height, height = _c === void 0 ? '13' : _c, _d = _a.color, color = _d === void 0 ? '#004C60' : _d;
	    return (React__default["default"].createElement("svg", { width: width, height: height, viewBox: '0 0 25 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        React__default["default"].createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.33634 0.630033C6.54067 0.815787 6.55572 1.13201 6.36997 1.33634L2.13299 5.99701H23.75C24.0261 5.99701 24.25 6.22087 24.25 6.49701C24.25 6.77316 24.0261 6.99701 23.75 6.99701H2.12756L6.36997 11.6637C6.55572 11.868 6.54067 12.1842 6.33634 12.37C6.13201 12.5557 5.81578 12.5407 5.63003 12.3363L0.63003 6.83634C0.456657 6.64563 0.456657 6.35438 0.63003 6.16367L5.63003 0.663667C5.81578 0.459338 6.13201 0.44428 6.33634 0.630033Z', fill: color })));
	};

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.page_header {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  display: grid;\n  grid-template-columns: 0.3fr 0.8fr 0.3fr;\n  grid-template-rows: 1fr;\n  grid-template-areas: \"col_1 col_2 col_3\" \"children children children\";\n  gap: 0.4rem;\n}\n.page_header > .small_column {\n  display: grid;\n  align-items: center;\n  justify-content: start;\n}\n.page_header > .small_column > button.primary_button {\n  white-space: nowrap;\n  padding: 0.5rem 1.5rem;\n}\n.page_header > .small_column.right_aligned {\n  justify-content: end;\n}\n.page_header > .col_1 {\n  grid-area: col_1;\n}\n.page_header > .col_2 {\n  display: grid;\n  grid-area: col_2;\n  align-items: center;\n  justify-content: center;\n  transition: height 5s;\n}\n.page_header > .col_2 > .header_1 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  font-family: AvenirLTStd-55-Roman, avenir_lt_roman, sans-serif;\n  color: #051d33;\n}\n.page_header > .col_3 {\n  grid-area: col_3;\n}\n.page_header > .children {\n  grid-area: children;\n}\n\n@media screen and (max-width: 767px) {\n  .page_header {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-areas: \"col_1 col_3\" \"col_2 col_2\" \"children children\";\n    -moz-column-gap: 1.5rem;\n         column-gap: 1.5rem;\n  }\n  .page_header > .col_1,\n  .page_header .col_3 {\n    margin-bottom: 2.25rem;\n  }\n  .page_header > .col_2 {\n    justify-content: flex-start;\n  }\n  .page_header > .col_2 > .header_1 {\n    font-size: 1.2rem;\n  }\n}";
	styleInject(css_248z);

	/**
	 * Page header, component to house Report title at center of the page
	 * Optionally:
	 *  'Go Back' button
	 * Notification Well
	 *
	 * Update to 2.0 changes:
	 * - change to grid css for structure and consistency
	 * - will span the full width of the container
	 * - add "Help" link
	 * - notification will be passed through component
	 * --------- Migration -----------
	 * As PageHeader will no longer render Notification based on passed props instead,
	 * pass Notification by wrapping it with <PageHeader> as children
	 */
	var PageHeader = function (_a) {
	    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.isGoBack, isGoBack = _c === void 0 ? false : _c, goBackHandler = _a.goBackHandler, _d = _a.helpLink, helpLink = _d === void 0 ? null : _d, children = _a.children, _e = _a.goBackLabel, goBackLabel = _e === void 0 ? 'Go back' : _e, // Should be go back button props once the button is revamped
	    _f = _a.goBackVariant, // Should be go back button props once the button is revamped
	    goBackVariant = _f === void 0 ? 'default' : _f;
	    // Go back handler to go to previous visited page via History
	    var handleGoBack = function () {
	        if (typeof goBackHandler === 'function') {
	            goBackHandler();
	        }
	        else {
	            // Should use react-router's history to keep with the app;
	            window.history.back();
	        }
	    };
	    return (React__default["default"].createElement("div", { "data-testid": 'page_header', className: 'page_header' },
	        React__default["default"].createElement("div", { className: classNames({
	                col_1: true,
	                small_column: true,
	            }), "data-testid": 'go_back_btn' },
	            isGoBack && goBackVariant === 'default' && (React__default["default"].createElement(dist$1.exports.PrimaryButton, { title: goBackLabel, clickHandler: handleGoBack })),
	            isGoBack && goBackVariant === 'arrow' && (React__default["default"].createElement("div", { "data-testid": 'go_back_arrow' },
	                React__default["default"].createElement(ResponsiveLink, { link: handleGoBack, linkText: goBackLabel, iconPosition: 'left' },
	                    React__default["default"].createElement(ThinLeftArrowIcon, { color: '#00677F' }))))),
	        React__default["default"].createElement("div", { className: classNames('page_title', 'col_2') },
	            React__default["default"].createElement("span", { className: 'header_1' }, title)),
	        React__default["default"].createElement("div", { className: classNames('small_column', 'right_aligned', 'col_3') }, helpLink),
	        React__default["default"].createElement("div", { className: 'children' }, children)));
	};

	return PageHeader;

}));
